import { render, staticRenderFns } from "./default-view.vue?vue&type=template&id=66265dfa&scoped=true"
import script from "./default-view.vue?vue&type=script&lang=js"
export * from "./default-view.vue?vue&type=script&lang=js"
import style0 from "./default-view.vue?vue&type=style&index=0&id=66265dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66265dfa",
  null
  
)

export default component.exports